module.exports = __webpack_public_path__ + "img/factor_c_red.f79b3f13.svg";